import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_btn_group = _resolveComponent("q-btn-group")!

  return (_openBlock(), _createBlock(_component_q_btn_group, { flat: "" }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resourceGroups, (resourceGroup) => {
        return (_openBlock(), _createBlock(_component_q_btn, {
          key: resourceGroup.label,
          label: resourceGroup.label,
          size: "sm",
          color: _ctx.getColor(resourceGroup),
          "text-color": _ctx.getTextColor(resourceGroup),
          onClick: ($event: any) => (_ctx.$emit('update:modelValue', resourceGroup))
        }, null, 8, ["label", "color", "text-color", "onClick"]))
      }), 128))
    ]),
    _: 1
  }))
}